import React from 'react';
import styled from 'styled-components';

const TextArea = styled.textarea`
  font-family: monospace;
  margin-top: 2.4em;
  min-height: 250px;
  width: 100%;
`;

const CandidateInput = (props) => {
  return (
    <form>
      <h1>Candidate</h1>
      <TextArea onChange={props.candidateOnChange} value={props.candidateVal} />
    </form>
  );
};

export default CandidateInput;



// WEBPACK FOOTER //
// ./src/CandidateInput.js